import styled from 'styled-components';
import { layout, colorUtils } from '@prisjakt/ui-base';
import {
  TextArea as TextAreaComponent,
  TextInput as TextInputComponent,
} from 'src/components/inputs';

export const TextWrapper = styled.div`
  max-width: 600px;
`;

export const TextArea = styled(TextAreaComponent)`
  textarea {
    border-radius: 2px;
    width: 100%;
    min-height: 100px;
  }
`;

export const TextInput = styled(TextInputComponent)`
  input {
    border-radius: 2px;
  }
`;

export const Counter = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 18px;
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.tertiary};
`;

type CountProps = {
  color: string;
};

export const Count = styled.span<CountProps>`
  display: flex;
  align-items: center;
  color: ${p => p.theme.text[p.color]};

  svg {
    margin-right: ${layout.measurements.spacing025};
  }
`;

type ErrorProps = {
  background?: boolean;
};

export const Error = styled.div<ErrorProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${p => (p.background ? layout.measurements.spacing100 : 0)};
  margin-top: ${layout.measurements.spacing050};
  color: ${p => p.theme.text.negative};
  background: ${p =>
    p.background
      ? colorUtils.setRgbaAlpha(p.theme.text.negative, '0.1')
      : 'none'};

  svg {
    margin-right: ${layout.measurements.spacing050};
  }
`;
